import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-inspection-evidences',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './inspection-evidences.component.html',
    styleUrl: './inspection-evidences.component.scss'
})
export class InspectionEvidencesComponent implements OnInit {
    @Input() inspectionId!: number;
    @Input() vehiclePlates!: string;
    @Input() serviceId!: number;

    isLoading: boolean = true;
    inspectionData: any = null;
    evidences: any = {
        dashboard: [],
        routine: [],
        damage: [],
        other: []
    };

    selectedImage: string | null = null;

    constructor(
        public modal: NgbModal,
        private http: HttpClient
    ) {}

    ngOnInit(): void {
        this.loadEvidences();
    }

    loadEvidences(): void {
        this.isLoading = true;

        const headers = new HttpHeaders().set('X-Api-Key', environment.API_KEY);

        this.http.get(
            `${environment.SERVICES_URL}/inspection/get-evidences?inspectionId=${this.inspectionId}`,
            { headers }
        ).subscribe({
            next: (response: any) => {
                this.isLoading = false;
                if (response.success) {
                    this.inspectionData = response.data.inspection;
                    this.evidences = response.data.evidences;
                } else {
                    this.showError(response.message);
                }
            },
            error: (error) => {
                this.isLoading = false;
                this.showError('Error al cargar evidencias: ' + error.message);
            }
        });
    }

    openImage(imageUrl: string): void {
        this.selectedImage = imageUrl;
    }

    closeImage(): void {
        this.selectedImage = null;
    }

    getIncidentTypesArray(): string[] {
        if (!this.inspectionData?.incidentTypes) return [];

        const translations: any = {
            'missing_items': 'Elementos faltantes',
            'mechanical_failure': 'Fallas mecánicas',
            'internal_damage': 'Daños internos',
            'external_damage': 'Daños externos'
            // NO incluimos 'other' para que no se muestre
        };

        return this.inspectionData.incidentTypes
            .split(',')
            .map((type: string) => type.trim())
            .filter((type: string) => type !== 'other' && translations[type]) // Filtrar "other"
            .map((type: string) => translations[type]);
    }

    showError(message: string): void {
        alert(message);
    }

    close(): void {
        this.modal.dismissAll();
    }
}
